import { render, staticRenderFns } from "./companies.vue?vue&type=template&id=0770662a&scoped=true"
import script from "./companies.vue?vue&type=script&lang=js"
export * from "./companies.vue?vue&type=script&lang=js"
import style0 from "./companies.vue?vue&type=style&index=0&id=0770662a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0770662a",
  null
  
)

export default component.exports